import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import styles from './Separator.module.scss';
export function Separator(param) {
    let { skin = 'default', spacing = 'medium', vertical, height } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: cn(vertical ? styles.verticalSeparator : styles.horizontalSeparator, styles["spacing-".concat(spacing)], styles["skin-".concat(skin)]),
        style: {
            blockSize: height
        }
    });
}
